import { render, staticRenderFns } from "./ProfilePhotoModal.vue?vue&type=template&id=a5ce3536&scoped=true"
import script from "./ProfilePhotoModal.vue?vue&type=script&lang=js"
export * from "./ProfilePhotoModal.vue?vue&type=script&lang=js"
import style0 from "./ProfilePhotoModal.vue?vue&type=style&index=0&id=a5ce3536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ce3536",
  null
  
)

export default component.exports